import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
import { CHECKOUT_URL } from './PremiumButton';
import { trackAddToCart } from '../lib/metaPixel';
import { ArrowRightIcon, FlameIcon, ZapIcon, ShieldCheckIcon, CheckCircle2Icon } from 'lucide-react';
export function NewFinalCTA() {
  return <section className="relative py-16 md:py-28 bg-forest text-cream text-center overflow-hidden border-b border-cream/10" data-id="element-338">
      {/* Soft radial glow behind the CTA */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-30 blur-3xl" style={{
      background: 'radial-gradient(circle, rgba(232,160,122,0.35) 0%, rgba(20,63,53,0) 70%)'
    }} aria-hidden="true" data-id="element-339" />

      <FadeIn className="container mx-auto px-5 max-w-[760px] relative z-10" data-id="element-340">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 border border-burgundy/60 bg-burgundy/20 rounded-full px-5 py-2 mb-7" data-id="element-341">
          <FlameIcon className="w-4 h-4 text-peach" data-id="element-342" />
          <span className="text-peach text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-343">
            Última oportunidad · 63% OFF
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-serif text-4xl md:text-6xl text-cream leading-[1.1] mb-5" data-id="element-344">
          Tu vientre plano está a{' '}
          <span className="italic text-peach" data-id="element-345">21 días</span>.
        </h2>

        <p className="text-sand/80 text-lg max-w-xl mx-auto mb-9 leading-relaxed" data-id="element-346">
          No esperes al "día perfecto". Empieza esta semana y tu cuerpo te lo
          agradecerá en el siguiente ciclo.
        </p>

        {/* Price */}
        <div className="flex items-center justify-center gap-4 mb-2" data-id="element-347">
          <span className="font-serif text-2xl md:text-3xl text-sand/50 line-through" data-id="element-348">
            $17.00
          </span>
          <span className="font-serif text-5xl md:text-6xl text-cream leading-none" data-id="element-349">
            $6.36
          </span>
        </div>
        <p className="text-sand/70 text-sm mb-9" data-id="element-350">
          Pago único · Acceso de por vida
        </p>

        {/* Strong pulsing CTA */}
        <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} aria-label="Sí, quiero mi vientre plano por $6.36" animate={{
        scale: [1, 1.045, 1],
        boxShadow: ['0 0 20px rgba(232,160,122,0.45)', '0 0 45px rgba(232,160,122,0.95)', '0 0 20px rgba(232,160,122,0.45)']
      }} transition={{
        duration: 1.4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.07
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center justify-center gap-3 bg-peach text-forest rounded-full px-10 py-5 font-bold text-base md:text-lg tracking-wide cursor-pointer" data-id="element-351">
          SÍ, QUIERO MI VIENTRE PLANO POR $6.36
          <ArrowRightIcon className="w-5 h-5" data-id="element-352" />
        </motion.a>

        {/* Trust row */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-8 text-sm text-sand/80" data-id="element-353">
          <div className="flex items-center gap-2" data-id="element-354">
            <ZapIcon className="w-4 h-4 text-peach" data-id="element-355" />
            <span data-id="element-356">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-357">
            <ShieldCheckIcon className="w-4 h-4 text-peach" data-id="element-358" />
            <span data-id="element-359">Garantía de 30 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-360">
            <CheckCircle2Icon className="w-4 h-4 text-peach" data-id="element-361" />
            <span data-id="element-362">Sin suscripciones</span>
          </div>
        </div>
      </FadeIn>
    </section>;
}